import {
    createProgressReport,
    deleteProgressReport,
    editProgressReport,
    getProgressReportById,
    getProgressReports,
} from './progressReport.action';
export { progressReportReducer } from './progressReport.reducer';
export { watchProgressReports } from './progressReport.saga';

export const progressReportsActions = {
    /** Progress Reports */
    getProgressReports,
    getProgressReportById,
    createProgressReport,
    editProgressReport,
    deleteProgressReport,
    /** End */
};
